import { Link } from "react-router-dom";
import { ArrowRight, Phone, Mail, MessageCircle } from "lucide-react";
import { COMPANY } from "@/lib/constants";

export const CTASection = () => (
  <section
    data-testid="cta-section"
    className="bg-zinc-50 border-y border-zinc-200"
  >
    <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-12 py-20 md:py-24">
      <div className="grid lg:grid-cols-[1.4fr_1fr] gap-12 lg:gap-16 items-start">
        {/* LEFT */}
        <div>
          <div className="inline-flex items-center gap-3 text-xs font-bold uppercase tracking-[0.25em] text-zinc-500">
            <span className="h-px w-8 bg-[#EAB308]" />
            Let's Build Together
          </div>

          <h2 className="mt-5 text-3xl sm:text-4xl lg:text-5xl font-black tracking-tighter text-zinc-950 leading-[1.05]">
            Have a panel <span className="text-[#EAB308]">requirement?</span>
          </h2>

          <p className="mt-5 max-w-xl text-base md:text-lg text-zinc-600 leading-relaxed">
            Share your project details — our engineering team analyzes your
            requirement and responds with the most reliable technical and
            commercial proposal.
          </p>

          <div className="mt-8 flex flex-wrap gap-3">
            <Link
              to="/contact"
              data-testid="cta-primary"
              className="inline-flex items-center gap-2 bg-navy-950 hover:bg-[#EAB308] hover:text-navy-950 text-white px-6 py-3.5 font-bold uppercase tracking-wide text-sm border-2 border-navy-950 transition-colors"
            >
              Discuss Your Panel Requirement
              <ArrowRight className="h-4 w-4" />
            </Link>
            <a
              href={`https://wa.me/${COMPANY.whatsapp}?text=Hi%20Prime%20Volt%2C%20I%27d%20like%20to%20discuss%20a%20panel%20requirement.`}
              target="_blank"
              rel="noreferrer"
              data-testid="cta-whatsapp"
              className="inline-flex items-center gap-2 bg-white hover:bg-[#22C55E] hover:text-white hover:border-[#22C55E] text-zinc-950 px-5 py-3.5 font-bold uppercase tracking-wide text-sm border-2 border-zinc-300 transition-colors"
            >
              <MessageCircle className="h-4 w-4" />
              WhatsApp
            </a>
            <a
              href={`tel:${COMPANY.phone}`}
              data-testid="cta-call"
              className="inline-flex items-center gap-2 bg-white hover:bg-navy-950 hover:text-white text-navy-950 px-5 py-3.5 font-bold uppercase tracking-wide text-sm border-2 border-zinc-300 hover:border-navy-950 transition-colors"
            >
              <Phone className="h-4 w-4" />
              Call Now
            </a>
          </div>

          <p className="mt-6 text-xs font-bold uppercase tracking-[0.2em] text-zinc-500">
            Typical Response · Under 24 Hours
          </p>
        </div>

        {/* RIGHT — clean contact card */}
        <div className="bg-white border border-zinc-200">
          <a
            href={`tel:${COMPANY.phone}`}
            className="block group px-6 py-5 border-b border-zinc-200 hover:bg-zinc-50 transition-colors"
          >
            <div className="flex items-start justify-between gap-4">
              <div>
                <div className="text-xs font-black uppercase tracking-[0.25em] text-zinc-500">
                  Direct Line
                </div>
                <div className="mt-1.5 text-xl md:text-2xl font-black tracking-tighter text-zinc-950 group-hover:text-[#CA8A04]">
                  {COMPANY.phoneDisplay}
                </div>
              </div>
              <Phone className="h-5 w-5 text-[#EAB308] mt-1" />
            </div>
          </a>

          <a
            href={`mailto:${COMPANY.email}`}
            className="block group px-6 py-5 border-b border-zinc-200 hover:bg-zinc-50 transition-colors"
          >
            <div className="flex items-start justify-between gap-4">
              <div className="min-w-0">
                <div className="text-xs font-black uppercase tracking-[0.25em] text-zinc-500">
                  Email
                </div>
                <div className="mt-1.5 text-sm font-bold text-zinc-950 group-hover:text-[#CA8A04] break-all">
                  {COMPANY.email}
                </div>
              </div>
              <Mail className="h-5 w-5 text-[#EAB308] mt-1 shrink-0" />
            </div>
          </a>

          <div className="grid grid-cols-3 divide-x divide-zinc-200">
            {[
              { k: "25+", v: "Projects" },
              { k: "24h", v: "Response" },
              { k: "100%", v: "Compliance" },
            ].map((s) => (
              <div key={s.v} className="p-4 text-center">
                <div className="text-lg font-black tracking-tighter text-zinc-950">
                  {s.k}
                </div>
                <div className="mt-0.5 text-xs uppercase tracking-[0.2em] text-zinc-500 font-bold">
                  {s.v}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  </section>
);
